import React from 'react';

/**
 * 任务复选框图标组件
 * 从TaskItem.tsx第130-134行和FocusTaskItem.tsx第456-459行完全提取
 */
interface TaskCheckboxProps {
  isDone: boolean;
  className?: string; // 为未来样式扩展预留
}

export const TaskCheckbox: React.FC<TaskCheckboxProps> = ({
  isDone,
  className = ""
}) => {
  return (
    <>
      {isDone && (
        <svg className={`w-3.5 h-3.5 text-white ${className}`} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 3L4.5 8.5L2 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
    </>
  );
};